// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".radio[data-v-85b19336] {\n  width: 14px;\n  height: 14px;\n  border-radius: 15px;\n  border: 0.5px solid #979797;\n}\n.checked[data-v-85b19336] {\n  border: none;\n  background: #3999FB;\n  box-shadow: 0px 0px 10px 0px rgba(58, 153, 252, 0.35);\n}\n.disabled[data-v-85b19336] {\n  background: #999 !important;\n}\n", ""]);
// Exports
module.exports = exports;
